import React from 'react'
import { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { GridHookForm } from 'vnetwork-ui'

interface IdentificationTabProps {
    formControl: UseFormReturn<any>
    onNext?: () => void
    onPrevious?: () => void
}

const IdentificationTab: React.FC<IdentificationTabProps> = ({
    formControl,
    onNext,
    onPrevious,
}) => {
    const { t } = useTranslation()

    return (
        <div className="space-y-6">
            <GridHookForm
                subForm={true}
                formControl={formControl}
                className="grid grid-cols-1 md:grid-cols-2 gap-4"
                data={[
                    {
                        formItemProps: {
                            type: 'textfield',
                            name: 'employee_idno',
                            placeholder: t('employees.idno'),
                            label: t('employees.idno') + ' *',
                        },
                    },
                    {
                        formItemProps: {
                            type: 'datepicker',
                            name: 'employee_idno_issued_on',
                            placeholder: t('employees.idno_issued_on'),
                            label: t('employees.idno_issued_on') + ' *',
                        },
                    },
                    {
                        formItemProps: {
                            type: 'textfield',
                            name: 'employee_idno_issued_by',
                            placeholder: t('employees.idno_issued_by'),
                            label: t('employees.idno_issued_by') + ' *',
                        },
                        className: 'md:col-span-2',
                    },
                ]}
                actions={[
                    {
                        title: t('employees.previous_step'),
                        type: 'button',
                        variant: 'outlined',
                        handler: () => {
                            formControl?.handleSubmit(onPrevious as any)()
                        },
                    },
                    {
                        title: t('employees.next_step'),
                        type: 'button',
                        variant: 'contained',
                        handler: () => {
                            formControl?.handleSubmit(onNext as any)()
                        },
                    },
                ]}
            />
        </div>
    )
}

export default IdentificationTab
